import { createAction, props } from '@ngrx/store';

export const showError = createAction('[Sales.Error] Show Error', props<{ payload?: string }>());
